import React from 'react';

export default function setRailsContext(Component) {
  return (props, railsContext) => (
    <Component {...{...props, railsContext}} />
  );
};